import React from "react";
import "./style.scss";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getRegions } from "redux/actions/regionActions";
import { isAggregatorUser, isAdminUser } from "utils/helper";
import AgentTransactionDashboard from "./AgentTransactions";
import AdminTransactionDashboard from "./AdminTransactions";
import { NewDateFIlterModal as DateFilterModal } from "components";
import { getTransactionTypes } from "redux/actions/transactionActions";
import AggregatorTransactionsDashboard from "./AggregatorTransactions";
import {
  getAllTransactionsData,
  setTransactionQuery,
} from "redux/actions/transactionActions";

const Transactions = () => {
  const [openDateModal, setOpenDateModal] = useState(false);

  const {
    params: { dateFrom, dateTo },
    user,
  } = useSelector((state) => ({
    params: state.transactionsReducer.params,
    user: state.user.user,
  }));

  const handleModalClose = () => setOpenDateModal(false);
  const getAgentsData = () => {
    getAllTransactionsData();
    handleModalClose();
  };

  useEffect(() => {
    getTransactionTypes();
    getRegions();

    //eslint-disable-next-line
  }, []);

  return (
    <div className="dashboard-page-container terminal-stats-dashboard transaction-container ">
      {isAdminUser(user) ? (
        <AdminTransactionDashboard
          handleDateModalOpen={() => setOpenDateModal(true)}
        />
      ) : isAggregatorUser(user) ? (
        <AggregatorTransactionsDashboard
          handleDateModalOpen={() => setOpenDateModal(true)}
        />
      ) : (
        <AgentTransactionDashboard
          handleDateModalOpen={() => setOpenDateModal(true)}
        />
      )}

      <DateFilterModal
        dateFrom={dateFrom}
        dateTo={dateTo}
        openDateModal={openDateModal}
        onClose={handleModalClose}
        handleFromChange={(val) =>
          setTransactionQuery({
            name: "dateFrom",
            value: val,
          })
        }
        handleToChange={(val) =>
          setTransactionQuery({
            name: "dateTo",
            value: val,
          })
        }
        onButtonClick={getAgentsData}
      />
    </div>
  );
};

export default Transactions;
